/**
 * Datas do Prazo de edital no horário de Brasília (UTC−3, sem horário de verão
 * desde 2019), calculadas em milissegundos para não depender do fuso de quem
 * abre a página.
 */

const BRASILIA = 3 * 3600e3;
const DIA = 86400e3;
const MESES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

const partes = (iso) => iso.split('-').map(Number);

// Instante (ms) de uma data ISO e hora "HH:MM" em Brasília. Sem hora: 0h na
// abertura, 23h59min59s no encerramento.
export const instante = (data, hora, lado) => {
  const [a, m, d] = partes(data);
  const [h, min] = hora
    ? hora.split(':').map(Number)
    : lado === 'fim'
      ? [23, 59]
      : [0, 0];
  const seg = !hora && lado === 'fim' ? 59 : 0;
  return Date.UTC(a, m - 1, d, h, min, seg) + BRASILIA;
};

const diaDe = (t) => Math.floor((t - BRASILIA) / DIA);

export const horaLegivel = (hora) => {
  if (!hora) return null;
  const [h, m] = hora.split(':');
  return `${Number(h)}h${m && m !== '00' ? m : ''}`;
};

export const situacao = (d = {}, agora) => {
  if (!d.dataFim) return null;
  const fim = instante(d.dataFim, d.horaFim, 'fim');
  const ini = d.dataInicio
    ? instante(d.dataInicio, d.horaInicio, 'inicio')
    : null;
  if (ini !== null && agora < ini) {
    const n = diaDe(ini) - diaDe(agora);
    const hora = horaLegivel(d.horaInicio);
    if (n <= 0)
      return {
        estado: 'embreve',
        frase: `Abre hoje${hora ? `, às ${hora}` : ''}`,
      };
    return {
      estado: 'embreve',
      frase: n === 1 ? 'Abre amanhã' : `Abre em ${n} dias`,
    };
  }
  if (agora <= fim) {
    const n = diaDe(fim) - diaDe(agora);
    const hora = horaLegivel(d.horaFim);
    if (n <= 0)
      return {
        estado: 'ultimo',
        frase: `Último dia${hora ? `, até ${hora}` : ''}`,
      };
    return {
      estado: 'aberto',
      frase: n === 1 ? 'Termina amanhã' : `Faltam ${n} dias`,
    };
  }
  return { estado: 'encerrado', frase: 'Encerrado' };
};

const dia = (n) => (n === 1 ? '1º' : String(n));

export const periodo = (d = {}) => {
  if (!d.dataFim) return '';
  const [a2, m2, d2] = partes(d.dataFim);
  const hora = horaLegivel(d.horaFim);
  let texto;
  if (!d.dataInicio) {
    texto = `Até ${dia(d2)} de ${MESES[m2 - 1]} de ${a2}${hora ? `, às ${hora}` : ''}`;
  } else {
    const [a1, m1, d1] = partes(d.dataInicio);
    if (d.dataInicio === d.dataFim)
      texto = `Em ${dia(d1)} de ${MESES[m1 - 1]} de ${a1}`;
    else if (a1 === a2 && m1 === m2)
      texto = `De ${dia(d1)} a ${dia(d2)} de ${MESES[m2 - 1]} de ${a2}`;
    else if (a1 === a2)
      texto = `De ${dia(d1)} de ${MESES[m1 - 1]} a ${dia(d2)} de ${MESES[m2 - 1]} de ${a2}`;
    else
      texto = `De ${dia(d1)} de ${MESES[m1 - 1]} de ${a1} a ${dia(d2)} de ${MESES[m2 - 1]} de ${a2}`;
    if (hora) texto += `, até ${hora}`;
  }
  return `${texto} (horário de Brasília)`;
};

// Para as folhas do calendário: dia com dois dígitos e mês abreviado.
export const folha = (iso) => {
  const [, m, d] = partes(iso);
  return { dia: String(d).padStart(2, '0'), mes: MESES[m - 1].slice(0, 3) };
};

export const estadosDasEtapas = (etapas = [], agora) => {
  const hoje = diaDe(agora);
  return etapas.map((e) => {
    const ini = diaDe(instante(e.inicio, '', 'inicio'));
    const fim = diaDe(instante(e.fim || e.inicio, '', 'fim'));
    if (fim < hoje) return 'feita';
    return ini <= hoje ? 'atual' : 'futura';
  });
};

// "28/10" ou "28/10 a 01/11", como no edital.
export const datasDaEtapa = (e) => {
  const curta = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
  return !e.fim || e.fim === e.inicio
    ? curta(e.inicio)
    : `${curta(e.inicio)} a ${curta(e.fim)}`;
};
